import '../applied_filter_view.js.coffee'
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedGroupedElementsView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/grouped_elements/applied_grouped_elements_filter"]
  appliedGroupedElementsTemplate: JST["backbone/templates/monitoring/filters/grouped_elements/applied_general_grouped_elements"]
  unmodifiableByModerators: true

  render: ->
    @$el.html(@template(self: @))
    @allowClearFilter() unless @unmodifiableByModerators
    @_renderPrimaryElements()
    @_renderSecondaryElements()
    @_renderExcludedElements()
    @

  getTitle: =>
    I18n.t("monitoring.dashboard.filters.filter_names.#{@name}")

  _renderPrimaryElements: () ->
    return unless @_getElementsFor(@withPrefix(@_primaryName()))?.length > 0
    @$el.find("#primary_elements").html(@appliedGroupedElementsTemplate(
      self: @,
      applied_elements: @_getElementsFor(@withPrefix(@_primaryName()))
    ))

  _renderSecondaryElements: () ->
    return unless @_getElementsFor(@withPrefix(@_secondaryName()))?.length > 0
    @$el.find("#secondary_elements").html(@appliedGroupedElementsTemplate(
      self: @,
      applied_elements: @_getElementsFor(@withPrefix(@_secondaryName()))
    ))
    @$el.find('#applied-and-logic-span').show()

  _renderExcludedElements: () ->
    return unless @_getElementsFor(@withPrefix(@_excludedName()))?.length > 0
    @$el.find("#excluded_elements").html(@appliedGroupedElementsTemplate(
      self: @,
      applied_elements: @_getElementsFor(@withPrefix(@_excludedName()))
    ))
    @$el.find('#applied-exclude-logic-span').show()

  getDescription: (value) ->
    value

  clear: =>
    @searchQuery.resetField(@withPrefix(@_primaryName()))
    @searchQuery.resetField(@withPrefix(@_secondaryName()))
    @searchQuery.resetField(@withPrefix(@_excludedName()))
    @_triggerQueryChanged()

  apply: (event) =>
    parent = $(event.currentTarget).parent().parent()
    value = $(event.target).parent().find('.hidden_value').text()
    @removeFilter(value, @withPrefix(parent.attr('id')))
    @_triggerQueryChanged()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  shouldShow: ->
    (@_getElementsFor(@withPrefix(@_secondaryName()))?.length > 0) ||
      (@_getElementsFor(@withPrefix(@_primaryName()))?.length > 0) ||
      (@_getElementsFor(@withPrefix(@_excludedName()))?.length > 0)

  _getElementsFor: (group) ->
    @searchQuery.get(group)

  withPrefix: (search_query_field) ->
    search_query_field

  _primaryName: () ->
    ''

  _secondaryName: () ->
    ''

  _excludedName: () ->
    ''
